<template>
    <v-row>
        <v-col>
            <v-card>
                <v-card-title>Fordelingsindstillinger</v-card-title>
                <v-divider />
                <v-card-text>
                    <v-textarea auto-grow filled v-model="distributionSettings" />
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn text class="green--text" @click="updateDistributionSettings">Gem</v-btn>
                    <v-btn text class="primary--text" @click="resetDistributionSettings">Gendan standardindstillinger</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import jsonFormat from 'json-format'

export default {
    data () {
        return {
            distributionSettings: null
        }
    },
    methods: {
        async getDistributionSettings () {
            const response = await this.$http().get('controlpanel/rules')
            this.distributionSettings = jsonFormat(response.data)
        },
        async updateDistributionSettings () {
            await this.$http().put('controlpanel/rules', JSON.parse(this.distributionSettings))
        },
        async resetDistributionSettings () {
            await this.$http().post('controlpanel/rules/reset')
            this.getDistributionSettings()
        }
    },
    created () {
        this.getDistributionSettings()
    }
}
</script>